import { useEffect, useRef } from "react"

import { useCopilotState } from "@/lib/states/copilot-state"

// Returns true when focus sat inside the panel and was released.
export function releaseFocusInside(panel: HTMLElement | null): boolean {
	if (!panel) return false
	const active = document.activeElement
	if (!(active instanceof HTMLElement) || !panel.contains(active)) return false
	active.blur()
	return true
}

// Hands focus back to the page whenever the copilot hides, so the composer
// stops swallowing the single-key shortcuts. Also drops an unconsumed focus
// request: the panel stays mounted while hidden, so the request would otherwise
// focus a composer the user can't see. Attach the returned ref to the panel.
export function useReleaseCopilotFocus(isVisible: boolean) {
	const panelRef = useRef<HTMLDivElement | null>(null)
	useEffect(() => {
		if (isVisible) return
		useCopilotState.getState().consumeFocusRequest()
		releaseFocusInside(panelRef.current)
	}, [isVisible])
	return panelRef
}
